import React from "react";
import { Navigate } from "react-router-dom";
import { isSessionValid, logout } from "./Session";

const ProtectedRoute = ({ children }) => {
  if (!isSessionValid()) {
    logout(); // Clear invalid session
    return <Navigate to="/" replace />; // Redirect to login
  }
  return children;
};

export default ProtectedRoute;
